import Number from './number';

export default Number;
